/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : appMeta.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

const appMeta = {
  httpStatus: {
    SUCCESS: 200,
    BAD_REQUEST: 400,
  },
  authView: {
    LOGIN: 100,
    SIGNUP: 200,
    SIGNUP_VERIFY_OTP: 300,
    FORGOT_PASSWORD: 400,
    RESET_PASSWORD: 500,
  },
  textFieldTypes: {
    FULL_NAME: 100,
    EMAIL: 200,
    PASSWORD: 300,
    AUTHPASSWORD: 400,
    CONFIRM_PASSWORD: 500,
    OTP: 600,
  },
};

export default appMeta;
